/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Promise_4_DetailInputs */

const en_cap_promise_4_detail = /** @type {(inputs: Cap_Promise_4_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exceptions go to someone, with the context attached.`)
};

const lv_cap_promise_4_detail = /** @type {(inputs: Cap_Promise_4_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izņēmumi nonāk pie konkrēta cilvēka kopā ar kontekstu.`)
};

/**
* | output |
* | --- |
* | "Exceptions go to someone, with the context attached." |
*
* @param {Cap_Promise_4_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_promise_4_detail = /** @type {((inputs?: Cap_Promise_4_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Promise_4_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_promise_4_detail(inputs)
	return en_cap_promise_4_detail(inputs)
});